import { PromiseStatus } from "./../common/DataProvider"
import { useLayerFeatures } from "./useLayerFeatures"

/** Gets a sign feature layer's feature by featureId */
export const useFeatureLayerFeature = (
  featureLayer: __esri.FeatureLayer | undefined,
  featureId: string | undefined,
  outFields: string[] = ["*"]
): [__esri.Graphic | undefined, Error | undefined, PromiseStatus] => {
  const [results, error, status] = useLayerFeatures(
    featureLayer,
    {
      where: `OBJECTID=${featureId}`,
      outFields,
      returnGeometry: true,
    },
    !featureId
  )

  return [
    results?.features.length ? results.features[0] : undefined,
    error,
    status,
  ]
}
